import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserStore, userQueryKeys, type AuthResponse } from '@entities/user';
import { authApi } from './authApi';

/**
 * Мутации для всех auth-операций.
 * onSuccess синхронизирует Zustand-стор и Query-кэш.
 */

export function useRegisterMutation() {
  return useMutation({
    mutationFn: authApi.register,
  });
}

export function useVerifyMutation() {
  const setUser = useUserStore((s) => s.setUser);
  const qc = useQueryClient();

  return useMutation<AuthResponse, Error, { email: string; code: string }>({
    mutationFn: authApi.verify,
    onSuccess: (data) => {
      setUser(data.user);
      qc.setQueryData(userQueryKeys.me(), data.user);
    },
  });
}

export function useLoginMutation() {
  const setUser = useUserStore((s) => s.setUser);
  const qc = useQueryClient();

  return useMutation<AuthResponse, Error, { email: string; password: string }>({
    mutationFn: authApi.login,
    onSuccess: (data) => {
      setUser(data.user);
      qc.setQueryData(userQueryKeys.me(), data.user);
    },
  });
}

export function useRequestPasswordResetMutation() {
  return useMutation({
    mutationFn: authApi.requestPasswordReset,
  });
}

export function useConfirmPasswordResetMutation() {
  return useMutation({
    mutationFn: authApi.confirmPasswordReset,
  });
}

export function useLogoutMutation() {
  const reset = useUserStore((s) => s.reset);
  const qc = useQueryClient();

  return useMutation({
    mutationFn: authApi.logout,
    onSettled: () => {
      // Чистим всё независимо от успеха — куки уже могут быть невалидны.
      reset();
      qc.clear();
    },
  });
}
